import React, { useContext } from "react";
import DetailLayoutHeader from "../../CourseDetail/components/DetailLayout/components/DetailLayoutHeader";
import NavBar from "../Components/NavBar";
import style from "./index.module.scss";
import { queryRule, QueryRuleResult } from "API/scoreRule";
import useRequest from "Utils/useRequest";
import { ScoreContext } from "../Components/CourseScoreProvider/context";
import CustomEmpty from "../Components/CustomEmpty";
import { Link, useParams } from "react-router-dom";
import { isTrue } from "../../../Utils/filter";
import CourseScore from "../CourseScore";
import { Icon } from "antd";
import CourseRules from "./CourseRules";

interface IndexProps {
    courseName: string;
}
const Index = ({ courseName }: IndexProps) => {
    const { tab } = useParams();
    const { courseNo, courseSeq, weekTimeId } = useContext(ScoreContext);
    const [scoreInfo, { loading }] = useRequest<QueryRuleResult>(
        () => queryRule({ courseNo, courseSeq }),
        { silence: true },
        [courseNo, courseSeq]
    );

    const Btn = () => {
        return (
            <Link
                replace
                className={style.btn}
                to={`/course/detail/${courseNo}/${courseSeq}/${weekTimeId}/report`}>
                <Icon type="stock" style={{ fontSize: 24 }} />
                <p>学习报告</p>
            </Link>
        );
    };

    return (
        <div>
            <DetailLayoutHeader title={courseName} extra={<Btn />}>
                {isTrue(scoreInfo?.isProcess) && (
                    <div className={style.subTitle}>过程化考核</div>
                )}
            </DetailLayoutHeader>

            <NavBar tab={tab} courseName={courseName} />

            {tab === "detail" && scoreInfo?.visible === "1" && (
                // <CollapseLayout nav={<ScoreProportion />} navWidth={350}>
                <CourseScore />
                // </CollapseLayout>
            )}

            {tab === "detail" && scoreInfo?.visible !== "1" && (
                <CustomEmpty
                    imageStyle={{ height: 220 }}
                    style={{ height: 500 }}
                    image={require("./img/empty.png")}
                    description="任课教师暂未开放查看权限，请耐心等待">
                    <div className={style.description}>
                        <span className={style.descText}>
                            更多成绩信息，请点击
                        </span>
                        <Link
                            to={`/course/detail/${courseNo}/${courseSeq}/${weekTimeId}/report`}
                            className={style.toLink}>
                            学习报告
                        </Link>
                    </div>
                </CustomEmpty>
            )}

            {tab === "rules" && scoreInfo?.visible === "1" && (
                <div>
                    <CourseRules scoreInfo={scoreInfo} loading={loading} />
                </div>
            )}

            {tab === "rules" && scoreInfo?.visible !== "1" && (
                <CustomEmpty
                    imageStyle={{ height: 220 }}
                    style={{ height: 500 }}
                    image={require("./img/empty.png")}
                    description="任课教师暂未开放查看权限，请耐心等待">
                    <div className={style.description}>
                        <span className={style.descText}>
                            更多成绩信息，请点击
                        </span>
                        <Link
                            to={`/course/detail/${courseNo}/${courseSeq}/${weekTimeId}/report`}
                            className={style.toLink}>
                            学习报告
                        </Link>
                    </div>
                </CustomEmpty>
            )}
        </div>
    );
};

export default Index;
